import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutGrid2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="layout-grid-2, grid"><path d="M3.75 3.75H10.25V10.25H3.75V3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M13.75 3.75H20.25V10.25H13.75V3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M3.75 13.75H10.25V20.25H3.75V13.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M13.75 13.75H20.25V20.25H13.75V13.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
};

export default IconLayoutGrid2;
